import { companyApi } from '@/store/api/company/company.api';
import type { TypeAppDispatch } from '@/store/store';
import type { TypeCompany } from '@/types/company/types.company';

export const writeCompany = (dispatch: TypeAppDispatch, company: TypeCompany): void => {
    dispatch(companyApi.util.upsertQueryData('readCompany', undefined, company));
};
